import { RootState } from '@/store/index';
import { useSelector } from 'react-redux';
import WatchDesktopMainView from "./view";

export default function WatchDesktopMain(props: any) {
    const seriesDetails = useSelector((state: RootState) => state.seriesReducer.series);

    return (
        <>
            <WatchDesktopMainView
                currentVideoObj={props.currentVideoObj}
                isLoading={props.isLoading}
                seriesDetails={seriesDetails}
                seriesNotes={props.seriesNotes}
                updateCurrentVideoObj={props.updateCurrentVideoObj}
                videoChangingId={props.videoChangingId}
                playNextVideo={props.playNextVideo}
                isWelcomeSeries={props.isWelcomeSeries}
                seriesId={props.seriesId}
                isSubscribedSeries={props.isSubscribedSeries}
                isPGCourseSeries={props.isPGCourseSeries}
            />
        </>
    );
}
